export default __webpack_public_path__ + "static/media/export.0044ea95.svg";